export const TranslationsPA = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "ਆਰਡਰ ਆਨਲਾਈਨ",
        cart: "ਕਾਰਟ",
        open_24: "24 ਘੰਟੇ",
        closed: "ਬੰਦ",
        free: "ਮੁਫ਼ਤ",
        something_went_wrong: "ਕੁਛ ਗਲਤ ਹੈ",
        try_again: "ਦੋਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    },
    constants: {
        calendar: {
            days: {
                monday: "ਸੋਮਵਾਰ",
                tuesday: "ਮੰਗਲਵਾਰ",
                wednesday: "ਬੁੱਧਵਾਰ",
                thursday: "ਵੀਰਵਾਰ",
                friday: "ਸ਼ੁੱਕਰਵਾਰ",
                saturday: "ਸ਼ਨੀਵਾਰ",
                sunday: "ਐਤਵਾਰ",
            },
        },
        services: {
            pickup: "ਪਿੱਕ-ਅਪ",
            delivery: "ਡਿਲਵਰੀ",
            dine_in: "ਡਾਈਨ-ਇਨ",
            table_booking: "ਟੇਬਲ ਬੁਕਿੰਗ",
        },
        payment: {
            method: {
                cash: "ਕੈਸ਼",
                card: "ਕਾਰਡ",
                stripe: "ਕਰੇਡਿਟ ਕਾਰਡ",
                paypal: "ਪੇਅਪਾਲ",
                cardconnect: "ਕਰੇਡਿਟ ਕਾਰਡ",
                paygate_payweb: "ਪੇਅਗੇਟ ਪੇਅਵੈਬ",
                poli_pay: "ਪੋਲੀ ਪੇਅ",
                ipay88: "ਆਈਪੇਅ 88",
                bambora_apac: "ਬੰਬੋਰਾ APAC",
                pesapal: "ਪੇਸਾਪਾਲ",
                custom: "ਕਸਟਮ",
            },
            backend_method: {
                cash: "ਕੈਸ਼",
                card: "ਕਾਰਡ",
                stripe: "ਸਟਰਾਈਪ",
                paypal: "ਪੇਅਪਾਲ",
                cardconnect: "ਕਾਰਡ ਕਨੈਕਟ",
                paygate_payweb: "ਪੇਅਗੇਟ ਪੇਅਵੈਬ",
                poli_pay: "ਪੋਲੀ ਪੇਅ",
                ipay88: "ਆਈਪੇਅ 88",
                bambora_apac: "ਬੰਬੋਰਾ APAC",
                pesapal: "ਪੇਸਾਪਾਲ",
                custom: "ਕਸਟਮ",
            },
            status: {
                success: "ਸਕਸੈਸ",
                pending: "ਪੈਂਡਿਂਗ",
                error: "ਏਰਰ",
                refunded: "ਰਿਫੰਡ",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "ਰੀਮੂਵ",
                drop_here: "ਆਪਣੀ ਫਾਈਲ ਰੱਖੋ ਜਾਂ ਇੱਕ 'ਤੇ ਕਲਿਕ ਕਰੋ",
                accepts: "Accepts {{fileTypes}} files",
                errors: {
                    max_files: "Maximum of {{number}} allowed",
                    max_size: "Max file size of {{kilobytes}} KB",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "ਸਟੋਰ ਇਸ ਸਮੇਂ ਬੰਦ ਹੈ ਅਤੇ ਹੁਣੇ ਡਾਈ-ਇਨ ਆਰਡਰ ਨਹੀਂ ਹੋ ਸਕਦਾ। ਤੁਸੀਂ ਆਰਡਰ ਕਿਸੇ ਹੋਰ ਤਾਰੀਕ ਜਾਂ ਟਾਈਮ 'ਤੇ ਕਰ ਸਕਦੇ ਹੋ।",
            },
            buttons: {
                order: {
                    book_order: "ਟੇਬਲ ਬੁੱਕ ਕਰੋ / ਆਨ-ਲਾਈਨ ਆਰਡਰ",
                    order_online: "ਆਨ-ਲਾਈਨ ਆਰਡਰ",
                    book_table: "ਟੇਬਲ ਬੁੱਕ ਕਰੋ",
                    order: "ਆਰਡਰ",
                    book: "ਬੁੱਕ",
                    cart: "ਕਾਰਟ",
                    restart: "ਰੀ-ਸਟਾਰਟ",
                    closed: "ਸਟੋਰ ਬੰਦ ਹੈ",
                    not_accepting: "ਆਰਡਰ ਨਹੀਂ ਲੈ ਰਹੇ",
                },
            },
        },
        modals: {
            auth: {
                login: "ਲਾਗ-ਇਨ",
                register: "ਰਜਿਸਟਰ",
                register_commence: "ਜਾਰੀ ਰੱਖੋ",
                register_complete: "ਅਕਾਉਂਟ ਬਨਾਓ",
                register_confirmation_sent: "ਤੁਹਾਡੀ ਈ-ਮੇਲ 'ਤੇ ਇੱਕ ਕੰਨਡਰਮੇਸ਼ਨ ਕੋਡ ਭੇਜਿਆ ਹੈ, ਉਸ ਨੂੰ ਦਰਜ ਕਰੋ",
                register_confirmation_resent: "ਤੁਹਾਡੀ ਈ-ਮੇਲ 'ਤੇ ਇੱਕ ਕੰਨਡਰਮੇਸ਼ਨ ਕੋਡ ਦੋਬਾਰਾ ਭੇਜਿਆ ਹੈ, ਆਪਣਾ ਸਪੈਮ ਚੈੱਕ ਕਰੋ ਜਾਂ ਪਰੋਸੈਸ ਦੋਬਾਰਾ ਸ਼ੁਰੂ ਕਰੋ",
                register_restart: "ਰੀ-ਸਟਾਰਟ",
                register_resend_code: "ਕੋਡ ਦੋਬਾਰਾ ਭੇਜੋ",
                login_placeholder: "ਈ-ਮੇਲ",
                password_placeholder: "ਪਾਸਵਰਡ",
                confirm_password_placeholder: "ਕੰਨਫਰਮ ਪਾਸਵਰਡ",
                confirmation_code_placeholder: "ਈ-ਮੇਲ ਕੰਨਫਰਮੇਸ਼ਨ ਕੋਡ",
                accept_terms: "ਟਰਮਸ ਐਂਡ ਕੰਡੀਸ਼ਨਸ ਮਨਜ਼ੂਰ ਹੈ",
                accept_terms_view: "ਦੇਖੋ",
                login_facebook: "ਫੇਸਬੁੱਕ ਰਾਹੀਂ ਲੋਗ-ਇਨ ਕਰੋ",
                login_google: "ਗੂਗਲ ਰਾਹੀਂ ਲੋਗ-ਇਨ ਕਰੋ",
                benefits: "ਆਪਣੇ ਆਰਡਰਸ ਸੁਰਖਿਅਤ ਕਰਨ ਲਈ ਲੋਗ-ਇਨ ਕਰੋ ਜਾਂ ਅਕਾਊਂਟ ਬਣਾਓ",
                logged_in: "ਸਫਲਤਾਪੂਰਨ ਲੋਗ-ਇਨ ਹੋ ਗਿਆ ਹੈ",
                logged_out: "ਲੋਗ-ਆਊਟ ਹੋ ਗਿਆ ਹੈ",
                password_reset: {
                    init_button: "ਮੇਲ ਦੋਬਾਰਾ ਸੈਟ ਕਰਨ ਲਈ ਪਾਸਵਰਡ ਭੇਜੋ",
                    init_success: "ਪਾਸਵਰਡ ਦੋਬਾਰਾ ਸੈਟ ਕਰਨ ਲਈ ਲੰਿਕ ਤੁਹਾਡੀ ਮੇਲ 'ਤੇ ਭੇਜ ਦਿੱਤਾ ਹੈ",
                    complete_button: "ਪਾਸਵਰਡ ਦੋਬਾਰਾ ਸੈਟ ਕਰੋ",
                    complete_success: "ਪਾਸਵਰਡ ਦੋਬਾਰਾ ਸੈਟ ਹੋ ਗਿਆ ਹੈ, ਆਪਣੇ ਨਵੇਂ ਪਾਸਵਰਡ ਨਾਲ ਲੋਗ-ਇਨ ਕਰੋ",
                    forgot_password_text: "ਆਪਣਾ ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ ਹੋ? ",
                    forgot_password_link: "ਪਾਸਵਰਡ ਦੋਬਾਰਾ ਸੈਟ ਕਰੋ",
                    remember_password_text: "ਆਪਣਾ ਪਾਸਵਰਡ ਯਾਦ ਕਰੋ?",
                    remember_password_link: "ਪਿੱਛੇ ਜਾਓ?",
                    invalid_title: "ਪਾਸਵਰਡ ਰੀ-ਸੈਟ ਸਹੀ ਨਹੀਂ ਹੈ",
                    invalid_description: "ਇਹ ਪਾਸਵਰਡ ਰੀ-ਸੈਟ ਲੰਿਕ ਸਹੀ ਨਹੀਂ ਹੈ, ਦੋਬਾਰਾ ਨਵੀਂ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
                    invalid_link: "ਲੋਗ-ਇਨ 'ਤੇ ਜਾਓ",
                    title: "ਪਾਸਵਰਡ ਰੀ-ਸੈਟ",
                    description: "ਆਪਣੇ ਅਕਾਊਂਟ ਲਈ ਨਵਾਂ ਪਾਸਵਰਡ ਭਰੋ",
                },
                error_generic: "ਕੁਛ ਗਲਤ ਹੈ, ਦੋਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਸਾਨੂੰ ਸੰਪਰਕ ਕਰੋ",
                error_accept_terms: "ਕਿਰਪਾ ਟਰਮਸ ਅਤੇ ਕੰਡੀਸ਼ਨਸ ਨੂੰ ਸਵੀਕਾਰ ਕਰੋ",
                error_password_length: "ਪਾਸਵਰਡ ਲਈ ਘੱਟੋ-ਘੱਟ 6 ਅੱਖਰ ਭਰੋ",
                error_social: "ਕੁਛ ਗਲਤ ਹੈ, ਦੋਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਸਾਨੂੰ ਸੰਪਰਕ ਕਰੋ",
                error_confirmation_code: "ਕੰਨਫਰਮੇਸ਼ਨ ਕੋਰਡ ਸਹੀ ਨਹੀਂ ਹੈe",
                error_invalid_code: "ਕੰਨਫਰਮੇਸ਼ਨ ਕੋਰਡ ਸਹੀ ਨਹੀਂ ਹੈ",
                error_exists: "ਉਪਭੋਗਤਾ ਪਹਿਲਾ ਹੀ ਮੌਜੂਦ ਹੈ",
                error_invalid_email_pass: "ਈ-ਮੇਲ ਜਾਂ ਪਾਸਵਰਡ ਸਹੀ ਨਹੀਂ ਹੈ",
                error_password_no_match: "ਪਾਸਵਰਡ ਇੱਕ-ਦੂਜੇ ਨਾਲ ਨਹੀਂ ਮਿਲ ਰਹੇ",
                error_user_not_found: "ਇਸ ਈ-ਮੇਲ ਨਾਲ ਕੋਈ ਉਪਭੋਗਤਾ ਨਹੀਂ ਹੈ",
                error_invalid_email: "ਈ-ਮੇਲ ਸਹੀ ਨਹੀਂ ਹੈ",
                error_invalid_reset_token: "ਰੀ-ਸੈਟ ਲੰਿਕ ਸਹੀਂ ਨਹੀਂ ਹੈ, ਨਵੇਂ ਲਈ ਮੰਗ ਕਰੋ",
            },
            booking: {
                form: {
                    name: "ਪੂਰਾ ਨਾਮ",
                    email: "ਈ-ਮੇਲ",
                    phone: "ਫੋਨ ਨੰਬਰ",
                    number_of_people: "ਵਿਅਕਤੀਆਂ ਦੀ ਗਿਣਤੀ",
                    number_of_people_max: "ਵਿਅਕਤੀਆਂ ਦੀ ਗਿਣਤੀ ({{max_people}} Max)",
                    number_of_people_min: "ਵਿਅਕਤੀਆਂ ਦੀ ਗਿਣਤੀ ({{min_people}} Min)",
                    number_of_people_max_min: "ਵਿਅਕਤੀਆਂ ਦੀ ਗਿਣਤੀ (Between {{min_people}} to {{max_people}})",
                    notes: "ਨੋਟਸ / ਸਪੈਸ਼ਲ ਬੇਨਤੀ",
                    submit: "ਬੁਕਿੰਗ ਲਈ ਬੇਨਤੀ ਭਰੋ",
                    email_optional: "(ਵਿਕਲਪਿਕ)",
                    date: "ਤਾਰੀਖ",
                    duration: "ਮਿਆਦ",
                    seating: "ਉਪਲਬਧ ਸਮੇਂ",
                    number_of_guests: "ਮਹਿਮਾਨਾਂ ਦੀ ਗਿਣਤੀ",
                    notes_placeholder: "ਐਲਰਜੀ, ਮੌਕਾ, ਬੈਠਣ ਦੀ ਪਸੰਦ",
                    reserving: "ਰਿਜ਼ਰਵ ਹੋ ਰਿਹਾ ਹੈ...",
                    reserve_table: "ਟੇਬਲ ਬੁੱਕ ਕਰੋ",
                    please_choose_a_date_and_time: "ਕਿਰਪਾ ਕਰਕੇ ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ ਚੁਣੋ।",
                    invalid_people: "ਲੋਕਾਂ ਦੀ ਗਿਣਤੀ {{min}} ਅਤੇ {{max}} ਵਿਚਕਾਰ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ।",
                    party_size_max_fallback: "ਇਜਾਜ਼ਤਸ਼ੁਦਾ ਵੱਧ ਤੋਂ ਵੱਧ",
                    loading_available_times: "ਉਪਲਬਧ ਸਮੇਂ ਲੋਡ ਹੋ ਰਹੇ ਹਨ…",
                    select_a_date_to_see_available_times: "ਉਪਲਬਧ ਸਮੇਂ ਵੇਖਣ ਲਈ ਤਾਰੀਖ ਚੁਣੋ।",
                    no_times_available_for_this_date: "ਇਸ ਤਾਰੀਖ ਲਈ ਕੋਈ ਸਮਾਂ ਉਪਲਬਧ ਨਹੀਂ। ਕਿਰਪਾ ਕਰਕੇ ਕੋਈ ਹੋਰ ਦਿਨ ਚੁਣੋ।",
                    shift: "ਸ਼ਿਫਟ",
                    service_times: "ਸੇਵਾ ਸਮਾਂ",
                    new_shift: "ਨਵੀਂ ਸ਼ਿਫਟ",
                    time: "ਸਮਾਂ",
                    times: "ਸਮੇਂ",
                    unavailable: "ਉਪਲਬਧ ਨਹੀਂ",
                    available: "ਉਪਲਬਧ",
                    required_name: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਨਾਮ ਦਰਜ ਕਰੋ।",
                    required_phone: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਫ਼ੋਨ ਨੰਬਰ ਦਰਜ ਕਰੋ।",
                    required_email: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਈਮੇਲ ਦਰਜ ਕਰੋ।",
                    invalid_email: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਈਮੇਲ ਦਰਜ ਕਰੋ।",
                    required_terms: "ਬੁੱਕ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਸ਼ਰਤਾਂ ਸਵੀਕਾਰ ਕਰੋ।",
                    missing_custom_fields: "ਕਿਰਪਾ ਕਰਕੇ ਸਾਰੇ ਲਾਜ਼ਮੀ ਸਵਾਲਾਂ ਦੇ ਜਵਾਬ ਦਿਓ।",
                    reservation_is_unavailable: "ਰਿਜ਼ਰਵੇਸ਼ਨ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।",
                    please_contact_the_restaurant_directly: "ਕਿਰਪਾ ਕਰਕੇ ਰੈਸਟੋਰੈਂਟ ਨਾਲ ਸਿੱਧਾ ਸੰਪਰਕ ਕਰੋ।",
                    almost_done: "ਲਗਭਗ ਪੂਰਾ",
                    your_details: "ਤੁਹਾਡਾ ਵੇਰਵਾ",
                    tell_us_who_s_coming: "ਦੱਸੋ ਕੌਣ ਆ ਰਿਹਾ ਹੈ ਤਾਂ ਜੋ ਅਸੀਂ ਤੁਹਾਡੀ ਰਿਜ਼ਰਵੇਸ਼ਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰ ਸਕੀਏ।",
                    book_your_table: "ਆਪਣੀ ਟੇਬਲ ਬੁੱਕ ਕਰੋ",
                    choose_a_time_that_works_for_you: "ਆਪਣੇ ਲਈ ਢੁਕਵਾਂ ਸਮਾਂ ਚੁਣੋ।",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "ਆਪਣੀ ਬੁੱਕਿੰਗ ਬੇਨਤੀ ਭੇਜੋ, ਬਾਕੀ ਰੈਸਟੋਰੈਂਟ ਸੰਭਾਲ ਲਵੇਗਾ।",
                    select_date: "ਤਾਰੀਖ ਚੁਣੋ",
                    standard: "ਮਿਆਰੀ",
                    minutes: "ਮਿੰਟ",
                    next: "ਅੱਗੇ →",
                    back: "← ਪਿੱਛੇ",
                    accept_terms: "ਮੈਂ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਸਵੀਕਾਰ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ।",
                    info_1: "ਜਦੋਂ ਤੁਹਾਡੀ ਬੁਕਿੰਗ ਸਵੀਕਾਰ ਜਾਂ ਅਸਵੀਕਾਰ ਹੋ ਜਾਵੇਗੀ, ਤੁਹਾਨੂੰ ਈ-ਮੇਲ ਰਾਹੀਂ ਸੂਚਨਾ ਮਿਲ ਜਾਵੇਗੀ",
                },
                errors: {
                    not_found: "ਬੁਕਿੰਗ ਮੌਜੂਦ ਨਹੀਂ ਹੈ, ਇਹ ਡੀਲੀਟ ਹੋ ਗਈ ਹੈ",
                    generic: "ਕੁਝ ਗਲਤ ਹੈ, ਪੇਜ ਰਿਫਰੇਸ਼ ਕਰੋ ਜਾਂ ਸਾਨੂੰ ਸੰਪਰਕ ਕਰੋ",
                    something_went_wrong: "ਕੁਝ ਗਲਤ ਹੈ",
                    accept_terms: "ਕਿਰਪਾ ਟਰਮ ਅਤੇ ਕੰਡੀਸ਼ਨਸ ਸਵੀਕਾਰ ਕਰੋ",
                    required_phone: "ਕਿਰਪਾ ਆਪਣਾ ਫੋਨ ਨੰਬਰ ਭਰੋ",
                    required_email: "ਕਿਰਪਾ ਆਪਣੀ ਈ-ਮੇਲ ਭਰੋ",
                    required_name: "ਕਿਰਪਾ ਆਪਣਾ ਨਾਮ ਭਰੋ",
                    invalid_email: "ਕਿਰਪਾ ਸਹੀ ਈ-ਮੇਲ ਭਰੋ",
                    invalid_phone: "ਕਿਰਪਾ ਸਹੀ ਫੋਨ ਨੰਬਰ ਭਰੋ",
                    invalid_people: "ਵਿਅਕਤੀਆਂ ਦੀ ਗਿਣਤੀ ਸਹੀ ਨਹੀਂ ਹੈ",
                    booking_capacity_threshold: "ਇਸ ਸਮੇਂ ਲਈ ਅਸੀਂ ਪੂਰੀ ਤਰ੍ਹਾਂ ਬੁੱਕ ਹਾਂ। ਕਿਰਪਾ ਕਰਕੇ ਕੋਈ ਹੋਰ ਸਮਾਂ ਅਜ਼ਮਾਓ।",
                    slot_unavailable: "ਇਸ ਗਿਣਤੀ ਲਈ ਅਸੀਂ ਪੂਰੀ ਤਰ੍ਹਾਂ ਬੁੱਕ ਹਾਂ। ਕਿਰਪਾ ਕਰਕੇ ਕੋਈ ਹੋਰ ਸਮਾਂ ਅਜ਼ਮਾਓ।",
                    booking_date_paused: "ਇਸ ਤਾਰੀਖ ਲਈ ਬੁੱਕਿੰਗ ਰੋਕੀ ਗਈ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਕੋਈ ਹੋਰ ਦਿਨ ਚੁਣੋ।",
                    invalid_table_assignment: "ਉਹ ਟੇਬਲ ਤੁਹਾਡੇ ਸਮੂਹ ਨੂੰ ਨਹੀਂ ਬਿਠਾ ਸਕਦੀਆਂ। ਕਿਰਪਾ ਕਰਕੇ ਕੋਈ ਹੋਰ ਸਮਾਂ ਚੁਣੋ।",
                    exceeded_order_limit: "ਬਹੁਤ ਜ਼ਿਆਦਾ ਬੁੱਕਿੰਗ ਬੇਨਤੀਆਂ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
                    validation_failed_recaptcha_v3: "ਅਸਧਾਰਨ ਟ੍ਰੈਫਿਕ ਮਿਲਿਆ। ਕੀ ਤੁਸੀਂ VPN ਵਰਤ ਰਹੇ ਹੋ? ਉੱਪਰਲੀ ਤਸਦੀਕ ਪੂਰੀ ਕਰੋ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
                    validation_failed_recaptcha_v2: "ਬੁੱਕਿੰਗ ਸ਼ੁਰੂ ਨਹੀਂ ਹੋ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਕੋਈ ਹੋਰ ਤਰੀਕਾ ਵਰਤੋ। ਜੇ ਤੁਸੀਂ VPN ਵਰਤ ਰਹੇ ਹੋ ਤਾਂ ਪਹਿਲਾਂ ਇਸਨੂੰ ਬੰਦ ਕਰੋ।",
                    booking_already_exists: "ਇਹ ਰਿਜ਼ਰਵੇਸ਼ਨ ਪਹਿਲਾਂ ਹੀ ਭੇਜੀ ਜਾ ਚੁੱਕੀ ਹੈ। ਆਪਣਾ ਈਮੇਲ ਜਾਂਚੋ ਜਾਂ ਬੁੱਕਿੰਗ ਲਿੰਕ ਖੋਲ੍ਹੋ।",
                    invalid_party_size: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਗਿਣਤੀ ਚੁਣੋ।",
                    invalid_request: "ਅਵੈਧ ਬੇਨਤੀ। ਕਿਰਪਾ ਕਰਕੇ ਪੇਜ ਰੀਫ੍ਰੈਸ਼ ਕਰੋ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
                    table_booking_unavailable: "ਟੇਬਲ ਬੁੱਕਿੰਗ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।",
                },
            },
            cart: {
                title: "ਕਾਰਟ",
                proceed_to_checkout: "ਚੈੱਕਆਊਟ ਲਈ ਪਰੋਸੀਡ ਕਰੋ",
                edit_dish: "ਏਡਿਟ",
                remove_dish: "ਰੀਮੂਵ",
                no_items_1: "ਕਾਰਟ ਵਿੱਚ ਕੋਈ ਆਈਟਮ ਨਹੀਂ ਹੈ",
                no_items_2: "ਪਰੋਸੀਡ ਤੋਂ ਪਹਿਲਾ ਕੁਝ ਭਰੋ",
                free_delivery_notice: "ਤੋਂ ਉੱਪਰ ਆਰਡਰ 'ਤੇ ਡਿਲਵਰੀ ਫਰੀ {{value, currency}}",
                errors: {
                    min_order_promo: "Minimum cart value of {{value, currency}} required before this promo is applied",
                    min_order_delivery: "Minimum cart value of {{value, currency}} for delivery",
                },
                promo: {
                    heading: "ਪਰੋਮੋ ਕੋਡ",
                    placeholder: "ਆਪਣਾ ਪਰੋਮੋ ਕੋਡ ਭਰੋ",
                    add: " ਕੋਡ ਭਰੋ",
                    title: "Promo {{name}} added to cart",
                    fixed_discount: "{{value, currency}} Off",
                    percent_discount: "{{value}}% Off",
                    added_to_cart: "ਕਾਰਟ ਵਿੱਚ ਪਰੋਮੋ ਕੋਡ ਲਗ ਗਿਆ",
                    errors: {
                        not_found: "ਪਰੋਮੋ ਨਹੀਂ ਮਿਲ ਰਿਹਾ",
                        disabled: "ਪਰੋਮੋ ਅਸਮਰਥ ਹੈ",
                        not_available: "ਪਰੋਮੋ ਇਸ ਵਕਤ ਮੌਜੂਦ ਨਹੀਂ ਹੈ",
                        logged_in_only: "ਇਸ ਪਰੋਮੋ ਨੂੰ ਇਸਤੇਮਾਲ ਕਰਨ ਲਈ ਲੋਗ-ਇਨ ਕਰੋ",
                        already_used: "ਤੁਸੀਂ ਇਹ ਪਰੋਮੋ ਪਹਿਲਾ ਹੀ ਪ੍ਰਯੋਗ ਕਰ ਚੁੱਕੇ ਹੋ",
                        invalid: "ਇਹ ਪਰੋਮੋ ਹੋਰ ਵੈਧ ਨਹੀਂ ਹੈ",
                        invalid_service: "ਇਹ ਪਰੋਮੋ ਤੁਹਾਡੀ ਚੁਣੀ ਹੋਈ ਸੇਵਾਵਾਂ ਲਈ ਵੈਧ ਨਹੀਂ ਹੈ",
                        later_only: "ਸਿਰਫ ਪ੍ਰੀ-ਆਰਡਰ ਲਈ ਵੈਧ ਹੈ",
                        now_only: "ਸਿਰਫ ਤੁਰੰਤ ਆਰਡਰ ਲਈ ਵੈਧ ਹੈ ਨਾ ਕਿ ਪ੍ਰੀ-ਆਰਡਰ ਲਈ",
                        generic: "ਓਹ.. ਕੁਝ ਗਲਤ ਹੈ ਅਤੇ ਲੋਗ ਹੋ ਗਿਆ ਹੈ",
                        dishes_required_multi: "ਇਹ ਪ੍ਰੋਮੋ ਤਾਂ ਹੀ ਲਾਗੂ ਕੀਤਾ ਜਾਏਗਾ ਜਦੋਂ ਤੁਹਾਡੀ ਕਾਰਟ ਵਿੱਚ ਕੁਝ ਪਕਵਾਨ ਸ਼ਾਮਲ ਕੀਤੇ ਜਾਣਗੇ",
                        dishes_required_single: "ਇਹ ਪ੍ਰੋਮੋ ਸਿਰਫ ਲਈ ਲਾਗੂ ਕੀਤਾ ਜਾਵੇਗਾ '{{dish}}'",
                    },
                },
                tip: {
                    title: "ਆਰਡਰ ਟਿਪ",
                    placeholder: "ਇੱਕ ਆਰਡਰ ਟਿਪ ਸ਼ਾਮਲ ਕਰੋ",
                },
            },
            checkout: {
                title: "ਚੈਕ-ਆਊਟ",
                subtitle: "ਆਪਣੀ ਆਰਡਰ ਡੀਟੇਲ ਕੰਨਫਰਮ ਕਰੋ",
                details: {
                    service: "ਸਰਵਿਸ",
                    due: "ਬਕਾਇਆ",
                    due_now_asap: "ਹੁਣ / ਜਲਦ ਤੋਂ ਜਲਦ",
                    address: "ਡਿਲਵਰੀ ਦਾ ਪਤਾ",
                    total: "ਕੁਲ",
                    table: "ਟੇਬਲ",
                    store_location: "ਸਟੋਰ ਦਾ ਪਤਾ",
                },
                customer: {
                    title: "ਗਾਹਕ",
                    subtitle: "ਆਪਣੇ ਆਰਡਰ ਅਤੇ ਸੁਰਖਿਅਤ ਕਰਨ ਲਈ ਬਚਾਉਣ ਲਈ ਲੌਗਇਨ ਕਰੋ",
                    button: "ਲੌਗਇਨ",
                    name: "ਪੂਰਾ ਨਾਮ",
                    email: "ਈ-ਮੇਲ ਪਤਾ",
                    phone: "ਫ਼ੋਨ ਨੰਬਰ",
                    phone_important: "ਫ਼ੋਨ ਨੰਬਰ (ਮਹੱਤਵਪੂਰਨ)",
                    notes: "ਆਰਡਰ ਨੋਟਸ",
                    delivery_notes: "ਡਿਲੀਵਰੀ ਹਿਦਾਇਤਾਂ/ ਆਰਡਰ ਨੋਟਸ",
                    optional: "ਵਿਕਲਪਕ"
                },
                payment: {
                    title: "ਭੁਗਤਾਨ ਵਿਧੀ",
                },
                accept_terms: "ਸ਼ਰਤਾਂ ਨੂੰ ਸਵੀਕਾਰ ਕਰੋ",
                accept_terms_view: "ਦੇਖੋ",
                processing_order: "ਪ੍ਰੋਸੈਸਿੰਗ ਆਰਡਰ",
                warning: {
                    different_payment_currency: "ਸਟੋਰ ਦੀਆਂ ਕੀਮਤਾਂ ਅੰਦਰ ਹਨ {{store_currency}} ਪਰ ਭੁਗਤਾਨ ਵਿਧੀ ਅੰਦਰ ਹੈ {{payment_currency}}",
                    closing_soon: "ਜਲਦੀ ਹੀ ਬੰਦ ਹੋਣ ਕਰਕੇ, ਆਰਡਰ ਲਾਜ਼ਮੀ ਤੌਰ 'ਤੇ ਅੰਦਰ ਰੱਖੇ ਜਾਣੇ ਚਾਹੀਦੇ ਹਨ {{value}} ਮਿੰਟ",
                    closed: "ਮਾਫ਼ ਕਰਨਾ, ਇਹ ਸੇਵਾ ਬੰਦ ਹੋ ਗਈ ਹੈ ਅਤੇ ਆਰਡਰ ਸਵੀਕਾਰ ਨਹੀਂ ਕੀਤੇ ਜਾ ਰਹੇ ਹਨ",
                    expired: "ਅਸੀਂ ਹੁਣ ਤੁਹਾਡੇ ਚੁਣੇ ਹੋਏ ਸਮੇਂ 'ਤੇ ਤੁਹਾਡੇ ਆਰਡਰ ਨੂੰ ਪੂਰਾ ਨਹੀਂ ਕਰ ਸਕਦੇ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਦੀ ਤਾਰੀਖ ਜਾਂ ਸਮਾਂ ਚੁਣੋ",
                },
                errors: {
                    stripe_generic: "ਕ੍ਰੈਡਿਟ ਕਾਰਡ ਗਲਤੀ, ਦੁਬਾਰਾ ਜਾਂ ਕਿਸੇ ਹੋਰ ਵਿਧੀ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
                    stripe_loading_fail: "ਭੁਗਤਾਨ ਫਾਰਮ ਲੋਡ ਕਰਨ ਵਿੱਚ ਗਲਤੀ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
                    something_went_wrong: "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ ਹੈ",
                    paypal_generic: "PayPal ਵਿੱਚ ਕੁਝ ਗੜਬੜ ਹੋ ਗਈ, ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਕੋਈ ਹੋਰ ਭੁਗਤਾਨ ਵਿਧੀ ਚੁਣੋ",
                    payment_fail: "ਭੁਗਤਾਨ ਅਸਫਲ ਰਿਹਾ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਕਿਸੇ ਹੋਰ ਭੁਗਤਾਨ ਵਿਧੀ ਦੀ ਚੋਣ ਕਰੋ",
                    payment_cancelled: "ਭੁਗਤਾਨ ਰੱਦ ਕੀਤਾ ਗਿਆ ਹੈ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਕਿਸੇ ਹੋਰ ਭੁਗਤਾਨ ਵਿਧੀ ਦੀ ਚੋਣ ਕਰੋ",
                    payment_error: "ਔਨਲਾਈਨ ਭੁਗਤਾਨ 'ਤੇ ਪ੍ਰਕਿਰਿਆ ਕਰਨ ਵਿੱਚ ਗਲਤੀ, ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਕੋਈ ਹੋਰ ਭੁਗਤਾਨ ਵਿਧੀ ਚੁਣੋ",
                    payment_declined: "ਤੁਹਾਡੀ ਭੁਗਤਾਨ ਵਿਧੀ ਨੂੰ ਠੁਕਰਾ ਦਿੱਤਾ ਗਿਆ ਸੀ",
                    card_declined: "ਤੁਹਾਡੇ ਕਾਰਡ ਨੂੰ ਠੁਕਰਾ ਦਿੱਤਾ ਗਿਆ ਸੀ ਅਤੇ ਭੁਗਤਾਨ 'ਤੇ ਕਾਰਵਾਈ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ ਸੀ",
                    promo_max_uses_exceeded: "ਇਹ ਪ੍ਰੋਮੋ ਕੋਡ ਆਪਣੀ ਵਰਤੋਂ ਦੀ ਸੀਮਾ ਤੇ ਪਹੁੰਚ ਗਿਆ ਹੈ ਅਤੇ ਹੁਣ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।",
                    store_closed: "ਸਟੋਰ ਬੰਦ ਹੈ ਅਤੇ ਹੁਣ ਆਰਡਰ ਸਵੀਕਾਰ ਨਹੀਂ ਕਰ ਰਿਹਾ",
                    accept_terms: "ਕਿਰਪਾ ਕਰਕੇ ਸ਼ਰਤਾਂ ਨੂੰ ਸਵੀਕਾਰ ਕਰੋ",
                    required_payment: "ਕਿਰਪਾ ਕਰਕੇ ਭੁਗਤਾਨ ਵਿਧੀ ਚੁਣੋ",
                    required_phone: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਫ਼ੋਨ ਨੰਬਰ ਦਾਖਲ ਕਰੋ",
                    required_email: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀ ਈਮੇਲ ਦਾਖਲ ਕਰੋ",
                    required_name: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਨਾਮ ਦਰਜ ਕਰੋ",
                    invalid_email: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਈ-ਮੇਲ ਪਤਾ ਦਾਖਲ ਕਰੋ",
                    invalid_phone: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਫ਼ੋਨ ਨੰਬਰ ਦਾਖਲ ਕਰੋ",
                    invalid_cc_number: "ਤੁਹਾਡਾ ਕ੍ਰੈਡਿਟ ਕਾਰਡ ਨੰਬਰ ਅਵੈਧ ਹੈ",
                    retry_cc_number: "ਕੁਝ ਗੜਬੜ ਹੋ ਗਈ, ਆਪਣੇ ਕ੍ਰੈਡਿਟ ਕਾਰਡ ਨੰਬਰ ਨੂੰ ਦੁਬਾਰਾ ਦਾਖਲ ਕਰੋ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
                    closed: "ਸਟੋਰ ਬੰਦ/ਬੰਦ ਹੋ ਰਿਹਾ ਹੈ ਅਤੇ ਆਰਡਰ ਸਵੀਕਾਰ ਨਹੀਂ ਕਰ ਰਿਹਾ ਹੈ",
                    promo_login_required: "ਇਸ ਪ੍ਰੋਮੋ ਦੀ ਵਰਤੋਂ ਕਰਨ ਲਈ ਲੌਗ ਇਨ ਕੀਤਾ ਜਾਣਾ ਲਾਜ਼ਮੀ ਹੈ",
                    promo_used: "Yਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ ਇਸ ਪ੍ਰੋਮੋ ਦੀ ਵਰਤੋਂ ਕਰ ਚੁੱਕੇ ਹੋ",
                },
                button: {
                    continue: "ਭੁਗਤਾਨ ਕਰਨਾ ਜਾਰੀ ਰੱਖੋ",
                    place_order: "ਆਰਡਰ ਕਰੋ",
                },
            },
            customer: {
                age_v: {
                    title: "ਉਮਰ ਤਸਦੀਕ",
                    required_for_items: "ਕੁਝ ਚੀਜ਼ਾਂ ਦਾ ਆਰਡਰ ਦੇਣ ਦੀ ਲੋੜ ਹੈ",
                    min_age: "ਘੱਟੋ ਘੱਟ ਉਮਰ: {{age}} ਸਾਲ",
                    est_time: "ਅਨੁਮਾਨਿਤ ਤਸਦੀਕ ਸਮਾਂ: {{time}} ਘੰਟੇ",
                    upload_description: "ਤਸਦੀਕ ਲਈ ਹੇਠਾਂ ਆਪਣੀ ਆਈਡੀ ਅੱਪਲੋਡ ਕਰੋ। ਇੱਕ ਵਾਰ ਤਸਦੀਕ ਕੀਤੇ ਜਾਣ ਤੋਂ ਬਾਅਦ ਤੁਹਾਨੂੰ ਈ-ਮੇਲ ਰਾਹੀਂ ਸੂਚਿਤ ਕੀਤਾ ਜਾਵੇਗਾ। 2 ਐਮਬੀ ਦੇ ਵੱਧ ਤੋਂ ਵੱਧ ਆਕਾਰ ਦੇ ਨਾਲ 2 ਚਿੱਤਰਾਂ ਤੱਕ ਅੱਪਲੋਡ ਕਰੋ",
                    pending_description_1: "ਆਪਣੇ ਦਸਤਾਵੇਜ਼ ਜਮ੍ਹਾਂ ਕਰਵਾਉਣ ਲਈ ਤੁਹਾਡਾ ਧੰਨਵਾਦ। ਜਦੋਂ ਤੁਹਾਨੂੰ ਮਨਜ਼ੂਰੀ ਮਿਲ ਜਾਵੇਗੀ ਤਾਂ ਤੁਹਾਨੂੰ ਈ-ਮੇਲ ਰਾਹੀਂ ਸੂਚਿਤ ਕੀਤਾ ਜਾਵੇਗਾ",
                    pending_description_2: "ਆਪਣੀ ਤਸਦੀਕ ਸਥਿਤੀ ਨੂੰ ਅੱਪਡੇਟ ਕਰਨ ਲਈ ਪੰਨੇ ਨੂੰ ਤਾਜ਼ਾ ਕਰੋ। ਅਨੁਮਾਨਿਤ ਤਸਦੀਕ ਸਮਾਂ ਹੈ {{time}} ਘੰਟੇ",
                    approved_description: "ਤੁਹਾਡੇ ਖਾਤੇ ਦੀ ਪੁਸ਼ਟੀ ਕੀਤੀ ਗਈ ਹੈ ਅਤੇ ਤੁਸੀਂ ਸੀਮਤ ਮੀਨੂ ਤੋਂ ਆਰਡਰ ਕਰ ਸਕਦੇ ਹੋ",
                    rejected_description: "ਤੁਹਾਡੀ ਆਈਡੀ ਨੂੰ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ ਹੈ। ਜੇ ਤੁਸੀਂ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀ ਆਈਡੀ ਨੂੰ ਦੁਬਾਰਾ ਅੱਪਲੋਡ ਕਰੋ",
                    upload: "ਅੱਪਲੋਡ",
                    reupload: "ਦਸਤਾਵੇਜ਼ ਮੁੜ-ਅੱਪਲੋਡ",
                    go_back: "ਵਾਪਸ ਜਾਓ",
                    view_document: "ਦਸਤਾਵੇਜ਼ ਦੇਖੋ {{number}}",
                    status: {
                        unverified: "ਅਣ-ਤਸਦੀਕ ਸ਼ੁਦਾ",
                        pending: "ਮਨਜ਼ੂਰੀ ਦੀ ਉਡੀਕ",
                        approved: "ਸਫਲਤਾਪੂਰਵਕ ਤਸਦੀਕ ਕੀਤਾ ਗਿਆ",
                        rejected: "ਰੱਦ ਕੀਤਾ ਗਿਆ",
                    },
                },
                headings: {
                    sessions: "ਸੈਸ਼ਨ",
                    orders: "ਆਰਡਰ",
                    spend: "ਖਰਚ ਕਰੋ",
                    order_history: "ਆਰਡਰ ਇਤਿਹਾਸ",
                    loyalty_points: "ਵਫ਼ਾਦਾਰੀ ਦੇ ਅੰਕ",
                },
            },
            custom_payment: {
                title: "{{name}} ਭੁਗਤਾਨ ਫਾਰਮ",
                description: "ਤੁਸੀਂ ਸਾਡੇ ਆਨਲਾਈਨ ਭੁਗਤਾਨ ਫਾਰਮ 'ਤੇ ਪਹੁੰਚ ਗਏ ਹੋ। ਕਿਰਪਾ ਕਰਕੇ ਭੁਗਤਾਨ ਕਰਨ ਲਈ ਹੇਠਾਂ ਦਿੱਤੇ ਖੇਤਰਾਂ ਨੂੰ ਪੂਰਾ ਕਰੋ। ਜੇ ਕੋਈ ਰਕਮ ਦਾਖਲ ਨਹੀਂ ਕੀਤੀ ਜਾਂਦੀ, ਤਾਂ ਤੁਹਾਡੇ ਵੇਰਵੇ ਸੁਰੱਖਿਅਤ ਹੋ ਜਾਣਗੇ ਪਰ ਤੁਹਾਨੂੰ ਚਾਰਜ ਨਹੀਂ ਕੀਤਾ ਜਾਵੇਗਾ।",
                disabled: "ਇਸ ਆਨਲਾਈਨ ਭੁਗਤਾਨ ਪੰਨੇ ਨੂੰ ਸਹੀ ਢੰਗ ਨਾਲ ਸੰਰਚਨਾ ਨਹੀਂ ਕੀਤੀ ਗਈ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਇਸ ਮੁੱਦੇ ਨੂੰ ਸੁਧਾਰਨ ਲਈ ਸਾਈਟ ਮਾਲਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
                success: "ਤੁਹਾਡੀ ਅਦਾਇਗੀ 'ਤੇ ਸਫਲਤਾਪੂਰਵਕ ਕਾਰਵਾਈ ਕੀਤੀ ਗਈ ਸੀ ਅਤੇ ਤੁਹਾਡੇ ਵੇਰਵਿਆਂ ਨੂੰ ਬਚਾਇਆ ਗਿਆ ਹੈ। ਤੁਹਾਡਾ ਧੰਨਵਾਦ",
                back: "ਘਰ ਵਾਪਸ ਜਾਓ",
                fields: {
                    name: "ਪੂਰਾ ਨਾਮ",
                    email: "ਈ-ਮੇਲ ਪਤਾ",
                    reference: "ਭੁਗਤਾਨ ਰੈਫ",
                    amount: "ਰਕਮ ($)",
                    name_on_card: "ਕਾਰਡ 'ਤੇ ਨਾਮ",
                    submit: "ਭੁਗਤਾਨ ਜਮ੍ਹਾਂ ਕਰੋ",
                },
                warning: {
                    currency: "ਨੋਟ ਕਰੋ- ਭੁਗਤਾਨ ਰਕਮ ਅੰਦਰ {{actual}}, ਨਹੀਂ {{default}}",
                },
                errors: {
                    generic: "ਕੁਝ ਗੜਬੜ ਹੋ ਗਈ, ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
                    stripe_generic: "ਕ੍ਰੈਡਿਟ ਕਾਰਡ ਗਲਤੀ, ਪੰਨੇ ਨੂੰ ਤਾਜ਼ਾ ਕਰੋ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
                    payment_fail: "ਭੁਗਤਾਨ ਅਸਫਲ ਰਿਹਾ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਕਿਸੇ ਹੋਰ ਭੁਗਤਾਨ ਵਿਧੀ ਦੀ ਚੋਣ ਕਰੋ",
                    payment_cancelled: "ਭੁਗਤਾਨ ਰੱਦ ਕੀਤਾ ਗਿਆ ਹੈ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਕਿਸੇ ਹੋਰ ਭੁਗਤਾਨ ਵਿਧੀ ਦੀ ਚੋਣ ਕਰੋ",
                    payment_error: "ਔਨਲਾਈਨ ਭੁਗਤਾਨ 'ਤੇ ਪ੍ਰਕਿਰਿਆ ਕਰਨ ਵਿੱਚ ਗਲਤੀ, ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਕੋਈ ਹੋਰ ਭੁਗਤਾਨ ਵਿਧੀ ਚੁਣੋ",
                    payment_declined: "ਤੁਹਾਡੀ ਭੁਗਤਾਨ ਵਿਧੀ ਨੂੰ ਠੁਕਰਾ ਦਿੱਤਾ ਗਿਆ ਸੀ",
                    card_declined: "ਤੁਹਾਡੇ ਕਾਰਡ ਨੂੰ ਠੁਕਰਾ ਦਿੱਤਾ ਗਿਆ ਸੀ ਅਤੇ ਭੁਗਤਾਨ 'ਤੇ ਕਾਰਵਾਈ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ ਸੀ",
                    promo_max_uses_exceeded: "ਇਹ ਪ੍ਰੋਮੋ ਕੋਡ ਆਪਣੀ ਵਰਤੋਂ ਦੀ ਸੀਮਾ ਤੇ ਪਹੁੰਚ ਗਿਆ ਹੈ ਅਤੇ ਹੁਣ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।",
                },
            },
            dish: {
                add: "ਕਾਰਟ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰੋ",
                edit: "ਅੱਪਡੇਟ ਆਈਟਮ",
                notes: "ਵਿਸ਼ੇਸ਼ ਹਿਦਾਇਤਾਂ...",
                ingredients: {
                    title: "ਸਮੱਗਰੀ",
                    uncheck_remove: "ਹਟਾਉਣ ਲਈ ਅਣ-ਜਾਂਚ",
                },
                ingredients_title: "ਸਮੱਗਰੀ",
                combo: {
                    choose_dish: "ਇੱਕ ਡਿਸ਼ ਚੁਣੋ",
                },
                option_sets: {
                    conditions: {
                        select_one: "ਇੱਕ ਚੁਣੋ (ਲੋੜੀਂਦਾ)",
                        select_one_optional: "ਇੱਕ ਚੁਣੋ (ਵਿਕਲਪਕ)",
                        select_between: "ਵਿਚਕਾਰ ਚੋਣ ਕਰੋ {{min}} - {{max}} (ਲੋੜੀਂਦਾ)",
                        select_at_least: "ਘੱਟੋ ਘੱਟ ਚੁਣੋ {{qty}} (ਲੋੜੀਂਦਾ)",
                        select_up_to: "ਇਸ ਤੱਕ ਚੁਣੋ {{qty}} (ਵਿਕਲਪਕ)",
                        select_multiple: "ਕਈ ਚੁਣੋ (ਵਿਕਲਪਕ)",
                        free_amount: "ਪਹਿਲਾ {{qty}} ਮੁਫ਼ਤ/ {{selected}} ਚੁਣਿਆ ਗਿਆ",
                    },
                },
                error: "ਕਿਰਪਾ ਕਰਕੇ ਲਾਲ ਰੰਗ ਵਿੱਚ ਨਿਸ਼ਾਨਬੱਧ ਕਿਸੇ ਵੀ ਵਿਕਲਪਾਂ ਨੂੰ ਠੀਕ ਕਰੋ",
                added_to_cart: "ਕਾਰਟ ਵਿੱਚ ਆਈਟਮ ਸ਼ਾਮਲ ਕੀਤੀ ਗਈ",
            },
            map: {
                zone_fee: "ਡਿਲੀਵਰੀ ਫੀਸ",
                view_in_google: "ਗੂਗਲ ਮੈਪਸ ਵਿੱਚ ਦੇਖੋ",
            },
            portal_go_back: {
                title: "ਰੈਸਟੋਰੈਂਟ ਖੋਜ 'ਤੇ ਵਾਪਸ ਜਾਓ?",
                description: "ਤੁਹਾਡੇ ਕਾਰਟ ਵਿੱਚ ਕੋਈ ਵੀ ਚੀਜ਼ਾਂ ਗੁੰਮ ਹੋ ਜਾਣਗੀਆਂ",
                cancel: "ਰੱਦ ਕਰੋ",
                proceed: "ਵਾਪਸ ਜਾਓ",
            },
            order: {
                config: {
                    services: {
                        title: "ਸੇਵਾ ਚੁਣੋ",
                        table_booking: "ਬੁੱਕ ਟੇਬਲ",
                    },
                    address_custom: {
                        input_placeholder: "ਆਪਣਾ ਪਤਾ ਦਾਖਲ ਕਰੋ",
                    },
                    address: {
                        input_placeholder: "ਆਪਣਾ ਡਿਲੀਵਰੀ ਪਤਾ ਲੱਭੋ",
                        extras_placeholder: "ਵਿਕਲਪਕ ਹੈ : ਯੂਨਿਟ ਨੰਬਰ, ਬਿਲਡਿੰਗ ਨਾਮ ਆਦਿ।",
                        search_placeholder: "ਆਪਣੇ ਪਤੇ ਦੀ ਤਲਾਸ਼ ਕਰੋ",
                        not_found: "ਡਿਲੀਵਰੀ ਪਤਾ ਨਹੀਂ ਮਿਲਿਆ ਜਾਂ ਵੈਧ ਨਹੀਂ, ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
                        not_delivering: "ਅਸੀਂ ਇਸ ਸਮੇਂ ਇਸ ਪਤੇ 'ਤੇ ਨਹੀਂ ਪਹੁੰਚ ਰਹੇ ਹਾਂ",
                        not_in_range: "ਤੁਹਾਡਾ ਪਤਾ ਸਾਡੇ ਸਟੋਰ ਸਥਾਨ ਦੀ ਰੇਂਜ ਵਿੱਚ ਨਹੀਂ ਹੈ",
                        not_in_zone: "ਤੁਹਾਡਾ ਪਤਾ ਕਿਸੇ ਸਰਗਰਮ ਡਿਲੀਵਰੀ ਜ਼ੋਨ ਦੇ ਅੰਦਰ ਨਹੀਂ ਹੈ",
                    },
                    datetime: {
                        title: "ਤੁਹਾਨੂੰ ਆਪਣਾ ਆਰਡਰ ਕਦੋਂ ਪਸੰਦ ਆਵੇਗਾ",
                        due_now: "ਹੁਣ",
                        due_later: "ਬਾਅਦ ਵਿੱਚ",
                        service_not_available: "ਮਾਫ਼ ਕਰਨਾ, ਅਸੀਂ ਇਸ ਸਮੇਂ ਆਰਡਰ ਸਵੀਕਾਰ ਨਹੀਂ ਕਰ ਰਹੇ ਹਾਂ {{service}}",
                        currently_closed: "{{service}} ਵਰਤਮਾਨ ਸਮੇਂ ਬੰਦ ਹੈ ਪਰ ਤੁਸੀਂ ਬਾਅਦ ਵਿੱਚ ਆਰਡਰ ਕਰ ਸਕਦੇ ਹੋ",
                        due_unavailable: "ਅਣ-ਉਪਲਬਧ",
                        due_closed: "ਬੰਦ",
                        select_date: "ਮਿਤੀ ਚੁਣੋ",
                        select_time: "ਸਮਾਂ ਚੁਣੋ",
                        select_order_date: "ਆਪਣੀ ਆਰਡਰ ਮਿਤੀ ਚੁਣੋ",
                        select_order_time: "ਆਪਣੇ ਆਰਡਰ ਟਾਈਮ ਦੀ ਚੋਣ ਕਰੋ",
                        select_booking_date: "ਆਪਣੀ ਬੁਕਿੰਗ ਮਿਤੀ ਚੁਣੋ",
                        select_booking_time: "ਆਪਣੇ ਬੁਕਿੰਗ ਸਮੇਂ ਦੀ ਚੋਣ ਕਰੋ",
                        no_times_available: "ਚੁਣਨ ਲਈ ਕੋਈ ਸਮਾਂ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
                        date_today: "(ਅੱਜ)",
                        date_closed: "(ਬੰਦ)",
                        date_bookings_paused: "(ਬੁੱਕਿੰਗ ਰੋਕੀ ਗਈ)",
                        time_slot_closed: "ਬੰਦ",
                    },
                    number_of_people: {
                        placeholder: "ਲੋਕਾਂ ਦੀ ਸੰਖਿਆ",
                    },
                    table: {
                        select: "ਟੇਬਲ ਚੁਣੋ",
                        select_popup_title: "ਆਪਣਾ ਟੇਬਲ ਚੁਣੋ",
                        password: "ਟੇਬਲ ਪਾਸਵਰਡ",
                        password_warning: "ਅੱਗੇ ਵਧਣ ਲਈ ਆਪਣਾ ਟੇਬਲ ਪਾਸਵਰਡ ਦਾਖਲ ਕਰੋ",
                    },
                    warning: {
                        closed: "ਮਾਫ਼ ਕਰਨਾ, ਅਸੀਂ ਇਸ ਸਮੇਂ ਬੰਦ ਹਾਂ/ ਕਿਸੇ ਵੀ ਆਦੇਸ਼ ਨੂੰ ਸਵੀਕਾਰ ਨਹੀਂ ਕਰ ਰਹੇ ਹਾਂ",
                        not_available: "ਮਾਫ਼ ਕਰਨਾ, ਅਸੀਂ ਇਸ ਸਮੇਂ ਕੋਈ ਆਦੇਸ਼ ਸਵੀਕਾਰ ਨਹੀਂ ਕਰ ਰਹੇ ਹਾਂ",
                    },
                    start_button: "ਆਰਡਰ ਸ਼ੁਰੂ ਕਰੋ",
                },
                history: {
                    invalid: "ਮੁੜ-ਆਰਡਰ ਲਈ ਯੋਗ ਨਹੀਂ ਹੈ ਕਿਉਂਕਿ ਆਰਡਰ ਕੀਤੀਆਂ ਕੁਝ ਚੀਜ਼ਾਂ ਨੂੰ ਸੋਧਿਆ ਗਿਆ ਹੈ ਜਾਂ ਹੁਣ ਉਪਲਬਧ ਨਹੀਂ ਹਨ",
                },
                reorder: {
                    title: "ਤੁਰੰਤ ਮੁੜ-ਆਰਡਰ",
                    description: "ਆਪਣੇ ਪਿਛਲੇ ਆਰਡਰਾਂ ਤੋਂ ਚੀਜ਼ਾਂ ਨੂੰ ਆਸਾਨੀ ਨਾਲ ਆਰਡਰ ਕਰੋ",
                },
            },
            receipt: {
                errors: {
                    not_found: "ਆਰਡਰ ਨਹੀਂ ਲੱਭਿਆ ਗਿਆ, ਪੰਨੇ ਨੂੰ ਤਾਜ਼ਾ ਕਰੋ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
                    booking_not_found: "ਬੁੱਕਿੰਗ ਮੌਜੂਦ ਨਹੀਂ ਹੈ। ਸੰਭਵ ਹੈ ਕਿ ਇਹ ਮਿਟਾ ਦਿੱਤੀ ਗਈ ਹੋਵੇ",
                    generic: "ਕੁਝ ਗੜਬੜ ਹੋ ਗਈ, ਪੰਨੇ ਨੂੰ ਤਾਜ਼ਾ ਕਰੋ ਜਾਂ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
                },
                connection: {
                    connected: "ਰੀਅਲ-ਟਾਈਮ ਅੱਪਡੇਟ",
                    connecting: "ਕਨੈਕਟ ਹੋਣ ਵਾਲੇ ਰੀਅਲ-ਟਾਈਮ ਅੱਪਡੇਟ",
                    disconnected: "ਰੀਅਲ-ਟਾਈਮ ਅੱਪਡੇਟ ਡਿਸਕਨੈਕਟ ਕੀਤਾ ਗਿਆ",
                },
            },
            warnings: {
                logout: {
                    pretitle: "ਚੇਤਾਵਨੀ",
                    title: "ਲੌਗਆਊਟ",
                    body: "ਲੌਗਆਊਟ ਕਰਨ ਨਾਲ ਤੁਹਾਡੀ ਗੱਡੀ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤੀਆਂ ਗਈਆਂ ਕਿਸੇ ਵੀ ਚੀਜ਼ਾਂ ਨੂੰ ਹਟਾ ਦਿੱਤਾ ਜਾਵੇਗਾ",
                    cancel: "ਰੱਦ ਕਰੋ",
                    proceed: "ਅੱਗੇ ਵਧੋ",
                },
                order_restart: {
                    warning: "ਚੇਤਾਵਨੀ",
                    title: "ਆਰਡਰ ਵੇਰਵੇ ਬਦਲੋ",
                    body: "ਤੁਹਾਡੇ ਆਰਡਰ ਦੇ ਵੇਰਵਿਆਂ ਨੂੰ ਬਦਲਣਨਾਲ ਤੁਹਾਡੀ ਕਾਰਟ ਵਿੱਚ ਆਈਟਮਾਂ ਨੂੰ ਹਟਾ ਦਿੱਤਾ ਜਾਵੇਗਾ ਕਿਉਂਕਿ ਕੁਝ ਪਕਵਾਨ ਉਪਲਬਧ ਨਹੀਂ ਹੋ ਸਕਦੇ",
                    cancel: "ਰੱਦ ਕਰੋ",
                    proceed: "ਅੱਗੇ ਵਧੋ",
                },
                order_expired: {
                    subtitle: "ਮਹੱਤਵਪੂਰਨ",
                    title: "ਆਰਡਰ ਤੁਰੰਤ ਬਕਾਇਆ ਹੋ ਗਿਆ",
                    description: "ਤੁਹਾਡੇ ਆਰਡਰ ਲਈ ਚੁਣਿਆ ਗਿਆ ਸਮਾਂ ਹੁਣ ਦੂਰ ਨਹੀਂ ਹੈ। ਇਸ ਲਈ ਤੁਹਾਡੇ ਆਰਡਰ ਨੂੰ ਤੁਰੰਤ /ਏਐਸਏਪੀ ਕਰਕੇ ਸੋਧਿਆ ਗਿਆ ਹੈ",
                    button: "ਠੀਕ ਹੈ",
                },
                order_expiring: {
                    subtitle: "ਮਹੱਤਵਪੂਰਨ",
                    title: "ਆਰਡਰ ਡੈੱਡਲਾਈਨ ਜਲਦੀ ਹੀ ਖਤਮ ਹੋ ਰਹੀ ਹੈ",
                    description: "ਤੁਹਾਡਾ ਆਰਡਰ ਪਹਿਲਾਂ ਲਾਜ਼ਮੀ ਤੌਰ 'ਤੇ ਰੱਖਿਆ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ {{time, timeFromTimestamp}} ਨਹੀਂ ਤਾਂ ਇਹ ਹੁਣ ਵੈਧ ਨਹੀਂ ਹੈ",
                    button: "ਠੀਕ ਹੈ",
                },
            },
        },
        sections: {
            nav_top: {
                guest: "ਮਹਿਮਾਨ",
                login: "ਲੌਗਇਨ",
                login_signup: "ਲੌਗਇਨ / ਸਾਈਨ ਅੱਪ",
                logout: "ਲੌਗਆਊਟ",
            },
            menus: {
                info: {
                    no_menus: "ਇਸ ਸਮੇਂ ਕੋਈ ਮੀਨੂ ਉਪਲਬਧ ਨਹੀਂ ਹਨ",
                    restrictions: "ਮੀਨੂ ਪਾਬੰਦੀਆਂ",
                    not_available: "ਮੀਨੂ ਵਰਤਮਾਨ ਸਮੇਂ ਅਣ-ਉਪਲਬਧ",
                    unavailable: {
                        times: "ਮੀਨੂ ਉਪਲਬਧ ਨਹੀਂ ਹੈ, ਤੁਹਾਡੀਆਂ ਆਰਡਰ ਲੋੜਾਂ ਹੇਠਾਂ ਮੇਲ ਨਹੀਂ ਖਾਂਦੀਆਂ",
                        services: "ਮੀਨੂ ਉਪਲਬਧ ਨਹੀਂ ਹੈ, ਤੁਹਾਡੀਆਂ ਆਰਡਰ ਲੋੜਾਂ ਹੇਠਾਂ ਮੇਲ ਨਹੀਂ ਖਾਂਦੀਆਂ",
                        hours: "ਮੀਨੂ ਉਪਲਬਧ ਨਹੀਂ ਹੈ, ਤੁਹਾਡੇ ਆਰਡਰ ਦੇ ਘੰਟੇ ਉਪਲਬਧ ਘੰਟਿਆਂ ਵਿੱਚ ਉਪਲਬਧ ਇਸ ਮੀਨੂ ਦੇ ਅੰਦਰ ਨਹੀਂ ਹਨ",
                        pre_order: "ਮੀਨੂ ਉਪਲਬਧ ਨਹੀਂ ਹੈ, ਤੁਹਾਡਾ ਆਰਡਰ ਪ੍ਰੀ-ਆਰਡਰ ਲੋੜਾਂ ਨਾਲ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ",
                        age: "ਮੀਨੂ ਉਪਲਬਧ ਨਹੀਂ ਹੈ, ਇਸ ਮੀਨੂ ਤੋਂ ਆਰਡਰ ਕਰਨ ਲਈ ਤੁਹਾਨੂੰ ਲਾਜ਼ਮੀ ਤੌਰ 'ਤੇ ਉਮਰ ਤਸਦੀਕ ਕੀਤੇ ਖਾਤੇ ਨਾਲ ਲੌਗ ਇਨ ਕੀਤਾ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ",
                    },
                    services: {
                        title: "ਆਰਡਰ ਲੋੜਾਂ",
                        pickup: "ਪਿਕਅੱਪ",
                        delivery: "ਡਿਲਵਰੀਸ",
                        dine_in: "ਡਾਈਨ-ਇਨ",
                    },
                    times: {
                        now: "ਕੋਈ ਪ੍ਰੀ-ਆਰਡਰ ਨਹੀਂ",
                        later: "ਕੇਵਲ ਪ੍ਰੀ-ਆਰਡਰ",
                    },
                    hours: {
                        title: "ਉਪਲਬਧ ਘੰਟੇ",
                    },
                    preorder: {
                        title: "ਪ੍ਰੀ-ਆਰਡਰ ਲੋੜਾਂ",
                        days_in_advance: "ਲਾਜ਼ਮੀ ਤੌਰ 'ਤੇ ਆਰਡਰ  {{days}} ਦਿਨ ਪਹਿਲਾਂ",
                        cutoff_time: "ਆਖਰੀ ਦਿਨ ਕੱਟ-ਆਫ ਸਮੇਂ 'ਤੇ {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "ਉਮਰ ਸੀਮਤ",
                        approved: "ਤੁਹਾਡਾ ਖਾਤਾ ਤਸਦੀਕ ਕੀਤਾ ਗਿਆ ਹੈ ਅਤੇ ਤੁਸੀਂ ਇਸ ਮੀਨੂ ਤੋਂ ਆਰਡਰ ਕਰ ਸਕਦੇ ਹੋ",
                        rejected: "ਆਰਡਰ ਕਰਨ ਲਈ ਉਮਰ ਤਸਦੀਕ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ। ਖਾਤਾ ਬਣਾਓ ਅਤੇ ਆਪਣੀ ਆਈਡੀ ਅੱਪਲੋਡ ਕਰੋ",
                    },
                },
            },
            info: {
                location: {
                    title: "ਟਿਕਾਣਾ",
                    view_map: "ਨਕਸ਼ਾ ਦੇਖੋ",
                    phone: "ਫ਼ੋਨ",
                },
                hours: {
                    title: "ਖੁੱਲ੍ਹਣ ਦੇ ਘੰਟੇ",
                    title_special: "ਵਿਸ਼ੇਸ਼ ਖੁੱਲ੍ਹਣ ਦੇ ਘੰਟੇ",
                },
                services: {
                    title: "ਸੇਵਾਵਾਂ",
                    notes: "ਨੋਟ",
                    delivery: {
                        ranges: "ਡਿਲੀਵਰੀ ਰੇਂਜ",
                        zones: "ਡਿਲੀਵਰੀ ਜ਼ੋਨ",
                        view_zones: "ਨਕਸ਼ੇ 'ਤੇ ਜ਼ੋਨ ਦੇਖੋ",
                        fee: "ਡਿਲੀਵਰੀ ਫੀਸ",
                        fee_short: 'ਫੀਸ',
                        fee_varies: "ਕਾਰਟ ਵਿੱਚ ਵੱਖ-ਵੱਖ, ਦਿਖਾਇਆ ਜਾਂਦਾ ਹੈ",
                        min_order: "ਘੱਟੋ ਘੱਟ ਆਰਡਰ",
                        min_order_short: 'ਘੱਟੋ-ਘੱਟ',
                        no_min_order: "ਕੋਈ ਘੱਟੋ ਘੱਟ ਆਰਡਰ ਨਹੀਂ",
                        free_amount: "ਮੁਫ਼ਤ ਡਿਲੀਵਰੀ ਰਕਮ",
                    },
                },
            },
            contact: {
                title: "ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
                name: "ਨਾਂ",
                email: "ਈਮੇਲ",
                phone: "ਫ਼ੋਨ ਨੰਬਰ",
                message: "ਆਪਣਾ ਸੁਨੇਹਾ ਦਾਖਲ ਕਰੋ...",
                send: "ਸੁਨੇਹਾ ਭੇਜੋ",
                success: "ਤੁਹਾਡਾ ਸੁਨੇਹਾ ਸਫਲਤਾਪੂਰਵਕ ਭੇਜਿਆ ਗਿਆ ਹੈ",
                error: "ਕੁਝ ਗੜਬੜ ਹੋ ਗਈ, ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਬਾਅਦ ਵਿੱਚ",
            },
            footer: {
                powered_by: "ਵੱਲੋਂ ਸੰਚਾਲਿਤ",
                terms_and_conditions: "ਸ਼ਰਤਾਂ",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'ਬੁਕਿੰਗ ਰਸੀਦ',
            details: {
                datetime: 'ਬੁਕਿੰਗ',
                number_of_people: 'ਲੋਕਾਂ ਦੀ ਸੰਖਿਆ',
                placed: 'ਰੱਖਿਆ ਗਿਆ',
                updated: 'ਆਖਰੀ ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ',
                notes: 'ਨੋਟ',
                name: 'ਨਾਂ',
                email: 'ਈਮੇਲ',
                phone: 'ਫ਼ੋਨ',
                store_address: 'ਸਟੋਰ ਪਤਾ',
            },
            status_update: {
                title: 'ਬੁਕਿੰਗ {{number}} ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ',
                body: 'ਤੁਹਾਡੀ ਬੁਕਿੰਗ ਸਥਿਤੀ ਨੂੰ ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ ਹੈ {{status}}',
            },
            email_status_update_customer: {
                subject: 'ਬੁੱਕਿੰਗ #{{number}} – {{subjectLabel}}',
                body: '{{store}} ਵਿਖੇ ਤੁਹਾਡੀ ਬੁੱਕਿੰਗ #{{number}} ਹੁਣ {{status}} ਹੈ।',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'ਆਰਡਰ #{{number}} – {{subjectLabel}}',
        header: 'ਅੱਪਡੇਟ ਕੀਤਾ ਤਿਆਰੀ ਸਮਾਂ',
        title: 'ਅੱਪਡੇਟ ਕੀਤਾ ਤਿਆਰੀ ਸਮਾਂ',
        order_number: 'ਕ੍ਰਮ ਸੰਖਿਆ: {{number}}',
        description: 'ਤੁਹਾਡਾ ਆਰਡਰ ਹੁਣ {{time}} ਵਜੇ ਤਿਆਰ ਹੋਵੇਗਾ।',
        order_time_updated_to: 'ਤੁਹਾਡੇ ਆਰਡਰ ਦਾ ਸਮਾਂ ਅੱਪਡੇਟ ਹੋ ਗਿਆ ਹੈ।',
        powered_by: 'ਦੁਆਰਾ ਸੰਚਾਲਿਤ {{name}}',
        button_text: 'ਟ੍ਰੈਕ ਆਰਡਰ',
        subject_label: 'ਅੱਪਡੇਟ ਕੀਤਾ ਤਿਆਰੀ ਸਮਾਂ',
        subject_label_delivery: 'ਅੱਪਡੇਟ ਕੀਤਾ ਡਿਲੀਵਰੀ ਸਮਾਂ',
        body_ready: 'ਤੁਹਾਡਾ ਆਰਡਰ ਹੁਣ {{time}} ਵਜੇ ਤਿਆਰ ਹੋਵੇਗਾ।',
        body_delivery: 'ਤੁਹਾਡਾ ਆਰਡਰ ਹੁਣ {{time}} ਵਜੇ ਪਹੁੰਚਾਇਆ ਜਾਵੇਗਾ।',
    },
    order: {
        receipt: {
            est_ready_time: ' ਤਿਆਰ ਸਮਾਂ ਅਨੁਮਾਨ',
            est_driver_pickup_time: 'ਡਰਾਈਵਰ ਪਿਕਅੱਪ ਟਾਈਮ ਅਨੁਮਾਨ',
            est_delivery_time: 'ਡਿਲੀਵਰੀ ਦਾ ਸਮਾਂ ਅਨੁਮਾਨ',
            tab_details: 'ਵੇਰਵੇ',
            tab_dishes: 'ਪਕਵਾਨ',
            details: {
                status: 'ਸਥਿਤੀ',
                placed: 'ਰੱਖਿਆ ਗਿਆ',
                due: 'ਬਕਾਇਆ',
                due_asap: 'ਹੁਣ / ਜਲਦ ਤੋਂ ਜਲਦ',
                last_updated: 'ਆਖਰੀ ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ',
                total: 'ਕੁੱਲ',
                type: 'ਕਿਸਮ',
                table: 'ਟੇਬਲ',
                number_of_people: 'ਲੋਕਾਂ ਦੀ ਸੰਖਿਆ',
                payment_method: 'ਭੁਗਤਾਨ ਵਿਧੀ',
                payment_status: 'ਭੁਗਤਾਨ ਸਥਿਤੀ',
                payment_currency: 'ਭੁਗਤਾਨ ਮੁਦਰਾ',
                notes: 'ਨੋਟ',
                name: 'ਨਾਂ',
                email: 'ਈਮੇਲ',
                phone: 'ਫ਼ੋਨ',
                distance: 'ਦੂਰੀ',
                driving_time: 'ਡਰਾਈਵਿੰਗ ਸਮਾਂ',
                delivery_zone: 'ਜ਼ੋਨ',
                delivery_address: 'ਡਿਲੀਵਰੀ ਪਤਾ',
                delivery_tracking: 'ਡਿਲੀਵਰੀ ਟਰੈਕਿੰਗ',
                delivery_tracking_link: 'ਰੀਅਲ-ਟਾਈਮ ਟਰੈਕਿੰਗ ਲਿੰਕ',
                tookan_status: 'ਟੇਕਨ ਸਟੇਟਸ',
                tookan_status_failed_book: 'ਡਿਲੀਵਰੀ ਬੁੱਕ ਕਰਨ ਵਿੱਚ ਅਸਫਲ ਰਿਹਾ',
                tookan_status_failed_update: 'ਬੁਕਿੰਗ ਨੂੰ ਅੱਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ ਰਿਹਾ',
                tookan_status_success: 'ਡਿਲੀਵਰੀ ਲਈ ਬੁੱਕ ਕੀਤਾ ਗਿਆ',
                store_address: 'ਸਟੋਰ ਪਤਾ',
            },
            dishes: {
                headings: {
                    quantity: 'ਮਾਤਰਾ',
                    item: 'ਆਈਟਮ',
                    price: 'ਕੀਮਤ',
                },
                notes: 'ਨੋਟ',
                remove_ingredients: 'ਸਮੱਗਰੀ ਹਟਾਓ',
            },
            status_update: {
                title: 'ਆਰਡਰ {{number}} ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ',
                body: 'ਤੁਹਾਡੇ ਆਰਡਰ ਦੀ ਸਥਿਤੀ ਨੂੰ ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ ਹੈ {{status}}',
            },
            wait_time_update: {
                title: 'ਆਰਡਰ {{number}} ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ',
                body: 'ਤੁਹਾਡੇ ਆਰਡਰ ਦੇ ਸਮੇਂ ਨੂੰ ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ ਹੈ',
            },
            delivery_update: {
                title: 'ਆਰਡਰ {{number}} ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ',
                body: 'ਤੁਹਾਡੇ ਆਰਡਰ ਨੂੰ ਡਿਲੀਵਰੀ ਲਈ ਬੁੱਕ ਕੀਤਾ ਗਿਆ ਹੈ। ਰੀਅਲ-ਟਾਈਮ ਟਰੈਕਿੰਗ ਲਿੰਕ ਦੇਖੋ',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "ਆਰਡਰ ਨੂੰ ਟ੍ਰੈਕ ਕਰੋ",
                track_delivery_button_text: "ਟਰੈਕ ਡਿਲਿਵਰੀ",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "ਆਰਡਰ ਨੂੰ ਟ੍ਰੈਕ ਕਰੋ",
                track_delivery_button_text: "ਟਰੈਕ ਡਿਲਿਵਰੀ",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) inc. in price",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "ਡਿਲੀਵਰੀ ਫੀਸ",
            promo: "Discount: {{name}} ({{value, currency}} + {{percent}}% Off)",
            promo_percent: "Discount: {{name}} ({{percent}}%)",
            promo_fixed: "Discount: {{name}}",
            promo_none: "Discount: {{name}}",
            cart: "ਕਾਰਟ",
            tip: "ਆਰਡਰ ਟਿਪ",
            total: "ਕੁੱਲ",
        },
        status: {
            unconfirmed: "ਅਣ-ਪੁਸ਼ਟੀ",
            confirmed: "ਪੁਸ਼ਟੀ ਕੀਤੀ ਗਈ",
            ready: "ਤਿਆਰ",
            on_route: "ਰੂਟ 'ਤੇ",
            complete: "ਪੂਰਾ",
            cancelled: "ਰੱਦ ਕੀਤਾ ਗਿਆ",
            seated: "ਬਿਠਾਇਆ ਗਿਆ",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "ਅਣ-ਉਪਲਬਧ",
                },
            },
            dish: {
                no_stock: "ਸਟਾਕ ਤੋਂ ਬਾਹਰ",
                not_available: "ਉਪਲਬਧ ਨਹੀਂ",
            },
        },
    },
};
//# sourceMappingURL=pa.js.map